<!-- <app-data-table class="funcionalidades"
                mainTitle="Funcionalidades"
                singleTitle="Funcionalidade"
                application="proof"
                routerPath="/feature"
                entityPath="/authfeature"
                orderColumns="authApp/name,name"
                gender="feminine"
                [entity]="authFeature"
                [columns]="this['columns']"
                [controls]="this['controls']">
</app-data-table> -->

<mat-card class="card-linnks margin-linnks">
  <mat-card-title>
    {{title}}
    <mat-card-subtitle>
      {{subtitle}}
    </mat-card-subtitle>
  </mat-card-title>

  <div class="ui-g">
    <div class="ui-g-12">
      <div class="ui-g-12">

      </div>
    </div>
  </div>

  <mat-card-content>
    <div class="box-content pt-2" *ngIf="!novaConta && !editarConta">
      <div class="row">
        <div class="col-sm-12">
          <div class="header-box">
            <div class="header-box-content" style="padding: 1.5rem !important;">
              <div class="actions-card">
                <app-toolbar [value]="toolbarMain"></app-toolbar>
              </div>
            </div>
          </div>

          <div class="box-content">
            <p-table class="table-system" #dt [columns]="this['columns']" [value]="registrosFeatures" [rows]="rows"
              [paginator]="true" [pageLinks]="pageLinks" [rowsPerPageOptions]="rowsPerPage" [style]="{'width':'100%'}"
              immutable="false" (onRowSelect)="selectCheckbox($event)" (onRowUnselect)="unselectCheckbox($event)"
              selectionMode="single">
              <ng-template pTemplate="header">
                <tr>
                  <th class="text-center" style="width: 40px;">
                  </th>

                  <th class="text-left" style="width: 300px;">
                    <span class="text-overflow-dynamic-container" [pSortableColumn]="'applicationName'">
                      <span class="text-overflow-dynamic-ellipsis">
                        Aplicação <p-sortIcon [field]="'applicationName'"></p-sortIcon>
                      </span>
                    </span>
                    <input class="form-control form-control-sm" type="text"
                      (input)="dt.filter($event.target.value, 'applicationName', 'contains')">
                  </th>

                  <th class="text-left">
                    <span class="text-overflow-dynamic-container" [pSortableColumn]="'name'">
                      <span class="text-overflow-dynamic-ellipsis">
                        Funcionalidade <p-sortIcon [field]="'name'"></p-sortIcon>
                      </span>
                    </span>
                    <input class="form-control form-control-sm" type="text"
                      (input)="dt.filter($event.target.value, 'name', 'contains')">
                  </th>

                  <th class="text-left" style="width: 150px;">
                    <span class="text-overflow-dynamic-container" [pSortableColumn]="'active'">
                      <span class="text-overflow-dynamic-ellipsis">
                        Ativa <p-sortIcon [field]="'active'"></p-sortIcon>
                      </span>
                    </span>
                    <p-dropdown #cmp class="type-p-mult" [options]="opcoesAtivo"
                      (onChange)="dt.filter($event.value, 'ativo', 'contains')"></p-dropdown>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData>
                <tr [pSelectableRow]="rowData">
                  <td class="text-center" style="width: 40px;" [id]="'checkboxContainer'+rowData.id">
                    <p-tableCheckbox [value]="rowData" (click)="selectCheckboxContainer(rowData)">
                    </p-tableCheckbox>
                  </td>

                  <td class="text-left">
                    <span class="text-overflow-dynamic-container">
                      <span class="text-overflow-dynamic-ellipsis" matTooltip="{{rowData.applicationName}}">
                        {{rowData.applicationName}}
                      </span>
                    </span>
                  </td>

                  <td class="text-left">
                    <span class="text-overflow-dynamic-container">
                      <span class="text-overflow-dynamic-ellipsis" matTooltip="{{rowData.name}}">
                        {{rowData.name}}
                      </span>
                    </span>
                  </td>

                  <td class="text-center">
                    <p-checkbox class="mr-1" [(ngModel)]="rowData.active" [binary]="true" inputId="ativo">
                      [disabled]="true"></p-checkbox>
                  </td>

                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-rowData>
                <tr>
                  <td [attr.colspan]="4" class="spaced-alert">
                    <div class="alert alert-xs alert-primary d-inline" role="alert">
                      <i class="fas fa-info-circle"></i> Nenhum registro encontrado!
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>



    <div class="row form-projeto" *ngIf="novaConta || editarConta">
      <div class="col-sm-6" style="min-width: 818px;">

        <div class="header-box">
          <div class="header-box-content" style="padding: 1.5rem !important;">
            <div class="actions-card">
              <app-toolbar [value]="toolbarMain"></app-toolbar>
            </div>
          </div>
        </div>

        <div class="box-content">
          <!-- <form> -->
          <div class="form-row">
            <div class="form-group col-sm-12">
              <label>Aplicação</label>
              <p-dropdown class="type-p-dropdown" placeholder="Selecione" [options]="aplicacoes"
                [(ngModel)]="selectedAplicacao" optionLabel="name" optionValue="id">
              </p-dropdown>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-sm-12">
              <label>Funcionalidade<span class="obrigatorio">*</span></label>
              <input class="form-control" id="key" type="text" pInputText required="true" [(ngModel)]="name">
            </div>
          </div>

          <div class="app-multi-select">
            <p-checkbox [(ngModel)]="selectedGruposAll" [ngModelOptions]="{standalone: true}" [binary]="true"
              class="select-all" (click)="selectGruposAll()">
            </p-checkbox>
            <label class="select-label">Grupos</label>

            <div class="clear"></div>

            <div class="clear multi-select-container">
              <div *ngFor="let grupo of grupos">
                <p-checkbox value={{grupo.id}} [(ngModel)]="selectedGrupos" [ngModelOptions]="{standalone: true}">
                </p-checkbox>
                <label for="{{grupo.name}}"> {{grupo.name}}</label>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-sm-12">
              <mat-slide-toggle [(ngModel)]="active">Ativa</mat-slide-toggle>
            </div>
          </div>

          <!-- </form> -->

        </div>
      </div>
    </div>


  </mat-card-content>
</mat-card>
